import { actionTextColor } from "../utils/themeContrast";
import React, { useEffect, useState } from "react";
import { ThemeContext, ActionContext, LanguageContext, UserContext } from "../contexts/Context";
import styled from "@emotion/styled";
import { Link } from "@reach/router";
import { IoAlertCircleOutline } from "react-icons/io5";
import { OrderIdentity } from "../newcomponents/OrderReceipt";
import { lightTint, readableText } from "../utils/themeContrast";
import axios from "axios";

const Fail = () => {
  const themeContext = React.useContext(ThemeContext);
  const languageContext = React.useContext(LanguageContext);

  const { addTakeAwayId } = React.useContext(ActionContext);
  const { isTakeAway, takeAwayId, lanIndex, currencySymbol, company } = React.useContext(UserContext);
  const [totalAmount, setTotalAmount] = useState(null);


  useEffect(() => {
    localStorage.removeItem("order");
  }, []);

  useEffect(() => {
    let orderId = localStorage.getItem("orderId");
    let token = localStorage.getItem("token");
    if (!token) return;
    axios.get(
      `/v2/api/selfOrder/takeAwayId?orderId=${orderId}`,
      { headers: { Authorization: "Bearer " + token } }
    )
      .then(function (response) {
        // handle success
        addTakeAwayId(response.data.takeAwayId);
        setTotalAmount(response.data.totalAmount);
      })
      .catch(function (response) {
        // handle error

      });
    //remove
    localStorage.removeItem("order");
  }, [addTakeAwayId]);

  if (typeof lanIndex === 'undefined') {
    return <></>
  }
  return (
    <BackgroundColor themeContext={themeContext}>
      {company && (company.shortName || company.companyName) &&
        <BusinessName>{company.shortName || company.companyName}</BusinessName>}
      <Content>
        <FailureCard themeContext={themeContext}>
          <StatusIcon themeContext={themeContext} aria-hidden="true"><IoAlertCircleOutline size={32} /></StatusIcon>
          <Header>{languageContext[lanIndex].orderFail}</Header>
          <Description>{languageContext[lanIndex].orderFailDesc}</Description>
        </FailureCard>
        <OrderIdentity takeAwayId={takeAwayId} />
        {isTakeAway && totalAmount !== null && Number.isFinite(Number(totalAmount)) &&
          <AmountRow themeContext={themeContext}>
            <span>{languageContext[lanIndex].totalAmount}</span>
            <strong>{currencySymbol}{Number(totalAmount).toFixed(2)}</strong>
          </AmountRow>}
      </Content>
      <Footer themeContext={themeContext}>
        <ReturnButton to="/menu" themeContext={themeContext}>
          {languageContext[lanIndex].returnMain || languageContext[lanIndex].returnCK}
        </ReturnButton>
      </Footer>
    </BackgroundColor>
  );
};
export default Fail;

const BackgroundColor = styled.main`
  width: 100vw; max-width: 550px; margin: 0 auto;
  min-height: 100vh;
  min-height: 100dvh; box-sizing: border-box;
  display: flex; flex-direction: column;
  background: ${p => p.themeContext.backgroundColor || '#fff'};
  color: ${p => readableText(p.themeContext.backgroundColor, p.themeContext.fontPrimary)};
  font-family: ${p => p.themeContext.fontFamily};
`;
const BusinessName = styled.div`
  padding: 20px 20px 0; text-align: center; font-size: 15px; font-weight: 600;
`;
const Content = styled.div`
  flex: 1; padding: 28px 16px 24px;
`;
const FailureCard = styled.section`
  padding: 24px 20px; border-radius: 18px;
  border: 1px solid ${p => lightTint(p.themeContext.primaryColor, .18)};
  text-align: center;
`;
const StatusIcon = styled.div`
  display: grid; place-items: center; width: 60px; height: 60px;
  margin: 0 auto 16px; border-radius: 50%;
  background: ${p => lightTint(p.themeContext.primaryColor, .09)};
  color: ${p => readableText(lightTint(p.themeContext.primaryColor, .09), p.themeContext.primaryColor)};
`;
const Header = styled.h1`
  margin: 0; font-size: 22px; line-height: 1.35; font-weight: 700;
`;
const Description = styled.p`
  margin: 10px 0 0; font-size: 14px; line-height: 1.6; opacity: .8;
  overflow-wrap: anywhere;
`;
const AmountRow = styled.div`
  display: flex; justify-content: space-between; align-items: baseline; gap: 16px;
  padding: 16px; margin-top: 16px; border-radius: 14px;
  border: 1px solid ${p => lightTint(p.themeContext.primaryColor, .18)};
  font-size: 14px;
  strong { font-size: 16px; text-align: right; }
`;
const Footer = styled.div`
  position: sticky; bottom: 0;
  padding: 12px 16px max(12px, env(safe-area-inset-bottom));
  background: ${p => p.themeContext.backgroundColor || '#fff'};
  border-top: 1px solid ${p => lightTint(p.themeContext.primaryColor, .18)};
`;
const ReturnButton = styled(Link)`
  display: flex; justify-content: center; align-items: center;
  width: 100%; min-height: 48px; padding: 12px 20px; box-sizing: border-box;
  border-radius: 999px; text-decoration: none;
  background: ${p => p.themeContext.primaryColor};
  color: ${p => actionTextColor(p.themeContext)};
  font-size: 14px; font-weight: 600; text-align: center;
  &:focus-visible { outline: 2px solid ${p => p.themeContext.primaryColor}; outline-offset: 3px; }
`;
